import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import adminDataService from "../../services/admin.service";

const MemberList = () => {
    const [users, setUsers] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [searchUsername, setSearchUsername] = useState("");

    let navigate = useNavigate();

    useEffect(() => {
        retrieveUsers();
    }, []);

    const dialog = useRef(null);
    const tableRef = useRef(null);

    const openDialog = () => {
        dialog.current.showModal();
    };

    const closeDialog = () => {
        dialog.current.close();
    };

    const handleDoubleClick = () => {
        navigate("/members/" + currentUser.id);
    };

    const handlePercentageChange = (e) => {
        let sum = Array.from(tableRef.current.childNodes).reduce(
            (acc, row) => acc + row.children[1].children[0].valueAsNumber,
            0
        );
        console.log(sum);
    };

    const handlePercSave = () => {
        // let rows = document.getElementById("percentages").childNodes;
        // let data = [...rows].map((v) => {
        //     return {
        //         username: v.children[0].innerText,
        //         familyPercentage: v.children[1].children[0].valueAsNumber,
        //     };
        // });
        // let sum = data.reduce((acc, row) => acc + row.familyPercentage, 0);
        // if (sum !== 100) {
        //     window.alert(
        //         `The total family percentage is ${sum}, it must precisely be 100%`
        //     );
        // } else {
        //     adminDataService
        //         .updatePercentages(data)
        //         .then((response) => {
        //             console.log(response.data);
        //             closeDialog();
        //             refreshList();
        //         })
        //         .catch((e) => {
        //             console.log(e);
        //         });
        // }
        const data = Array.from(tableRef.current.childNodes).map((row) => {
            const username = row.children[0].innerText;
            const familyPercentage = row.children[1].children[0].valueAsNumber;
            return { username, familyPercentage };
        });

        const sum = data.reduce((acc, row) => acc + row.familyPercentage, 0);

        if (sum !== 100) {
            window.alert(
                "The total family percentage is " +
                    sum +
                    ", it must precisely be 100%"
            );
            return;
        }

        adminDataService
            .updatePercentages(data)
            .then((response) => {
                console.log(response.data);
                closeDialog();
                refreshList();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const onChangeSearchUsername = (e) => {
        const searchUsername = e.target.value;
        setSearchUsername(searchUsername);
    };

    const retrieveUsers = () => {
        adminDataService
            .getAll()
            .then((response) => {
                setUsers(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                // console.log(e.response);
                // navigate(`/${e.response.status}-${e.response.statusText}`);
            });
    };

    const refreshList = () => {
        setUsers([]);
        retrieveUsers();
        setCurrentUser(null);
        setCurrentIndex(-1);
    };

    const setActiveUser = (user, index) => {
        setCurrentUser(user);
        setCurrentIndex(index);
    };

    const removeAllUsers = () => {
        adminDataService
            .removeAll()
            .then((response) => {
                console.log(response.data);
                refreshList();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const findByUsername = () => {
        adminDataService
            .findByUsername(searchUsername)
            .then((response) => {
                setUsers(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <div className="row">
            <nav className="navbar bg-body-tertiary module-nav">
                <div className="container-fluid">
                    <div className="nav-item">
                        <Link
                            to={"/members/add"}
                            className="m-1 btn btn-sm btn-success"
                        >
                            Add
                        </Link>

                        {/* <button
                            className="m-1 btn btn-sm btn-danger"
                            onClick={removeAllUsers}
                            disabled
                        >
                            Remove All
                        </button> */}

                        <button
                            className="m-1 btn btn-sm btn-warning"
                            onClick={() => {
                                navigate("/members/" + currentUser.id);
                            }}
                            disabled={!currentUser}
                        >
                            Edit
                        </button>

                        <button
                            className="m-1 btn btn-sm btn-primary"
                            onClick={() => {
                                openDialog();
                            }}
                        >
                            Set %
                        </button>

                        <dialog className="custom-dialog" ref={dialog}>
                            <table className="table">
                                <tbody id="percentages" ref={tableRef}>
                                    {users &&
                                        users.map((user, index) => (
                                            <tr
                                                key={index}
                                                style={{
                                                    userSelect: "none",
                                                    color: "rgba(15, 125, 250, 0.85)",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <td>{user.username}</td>
                                                <td>
                                                    <input
                                                        name={user.username}
                                                        type="number"
                                                        min={0}
                                                        max={100}
                                                        defaultValue={
                                                            user.familyPercentage
                                                        }
                                                        onChange={
                                                            handlePercentageChange
                                                        }
                                                    ></input>
                                                </td>
                                                <td>%</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            <button
                                className="m-1 btn btn-sm btn-outline-secondary"
                                onClick={() => {
                                    closeDialog();
                                }}
                            >
                                <i className="bi bi-arrow-left-square" /> Cancel
                            </button>
                            <button
                                className="m-1 btn btn-sm btn-outline-success"
                                onClick={handlePercSave}
                            >
                                <i className="bi bi-save"></i> Save
                            </button>
                        </dialog>
                    </div>

                    <form className="d-flex" role="search">
                        <div className="input-group">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                    searchUsername = "";
                                }}
                            >
                                <i className="bi bi-eraser"></i>
                            </button>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Username..."
                                value={searchUsername}
                                onChange={onChangeSearchUsername}
                                autoComplete={"new-password"}
                            />
                            <button
                                className="btn btn-outline-primary"
                                type="button"
                                onClick={findByUsername}
                            >
                                Search
                            </button>
                        </div>
                    </form>
                </div>
            </nav>

            <div className="col-md-10 module-table">
                <h4 className="page-title">Family Members</h4>

                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">username</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users &&
                            users.map((user, index) => (
                                <tr
                                    className={
                                        index === currentIndex
                                            ? "table-primary"
                                            : ""
                                    }
                                    onClick={() => setActiveUser(user, index)}
                                    onDoubleClick={handleDoubleClick}
                                    key={index}
                                    style={{ userSelect: "none" }}
                                >
                                    <th scope="row">{index + 1}</th>
                                    <td>{user.username}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <div className="col-md-2 module-detail">
                {currentUser ? (
                    <div className="inner-detail">
                        <h5>Detail</h5>
                        <div>
                            <label>
                                <strong>Username:</strong>
                            </label>{" "}
                            {currentUser.username}
                        </div>
                        <div>
                            <label>
                                <strong>Created at:</strong>
                            </label>{" "}
                            {new Date(currentUser.createdAt).toDateString()}
                        </div>
                        <div>
                            <label>
                                <strong>Updated at:</strong>
                            </label>{" "}
                            {new Date(currentUser.updatedAt).toDateString()}
                        </div>
                    </div>
                ) : (
                    <div>
                        <p>Please click on a Family Member...</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MemberList;
